import { useEffect, useState } from "react";
import FullScreenLoader from "../../components/Loader/FullScreenLoader";
import {
  Box,
  Button,
  Checkbox,
  gridClasses,
  IconButton,
  MenuItem,
  Popover,
  styled,
} from "@mui/material";
import { FaFileExcel, FaFilter } from "react-icons/fa";
import { DataGrid, GridMoreVertIcon } from "@mui/x-data-grid";
import "./ReorderInventory.scss";
import { HttpService } from "../../service/HttpService";
import { useAuth } from "../../context/AuthProvider";
import dayjs from "dayjs";
import { TbFilterEdit } from "react-icons/tb";
import DateTimeModal from "../Schedule/ScheduleListAdd/DateTimeModal";
import InventoryDownloadHandler from "./InventoryDownloadHandler";
import { handleDownloadPhysicalInventoryExcel } from "./DownloadPhysical";
import { handleDownloadReorderExcel } from "./DownloadReorder";
import { CiEdit } from "react-icons/ci";
import { HiOutlineEye } from "react-icons/hi2";
import { GoTrash } from "react-icons/go";
import DeleteModal from "../../components/Model/DeleteModal";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Encryption } from "../../Mixin/EncryptDecryptId";
import HistoryModal from "../Inventory/HistoryModal/HistoryModal";

const ReorderInventory = () => {
  const { setShowLoginPopup, showLoginPopup } = useAuth();
  const httpService = new HttpService(setShowLoginPopup);
  const [loading, setLoading] = useState(false);
  const [searchReorderData, setSearchReorderData] = useState([]);
  const [searchPhysicalData, setSearchPhysicalData] = useState([]);
  const [activeTab, setActiveTab] = useState();
  const [departments, setDepartment] = useState([]);
  const [reorder, setReorder] = useState([]);
  const [stocks, setStocks] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [dataId, setDataId] = useState();
  const [openDelete, setOpenDelete] = useState(false);
  const navigate = useNavigate();
  const reorderDateFilterData = JSON.parse(
    localStorage.getItem("reorderDateFilter")
  );
  const [openReorderDateModal, setOpenReorderDateModal] = useState(false);
  const [reorderStartDate, setReorderStartDate] = useState(
    reorderDateFilterData?.startDate ||
      dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [reorderEndDate, setReorderEndDate] = useState(
    reorderDateFilterData?.endDate ||
      dayjs().endOf("month").format("YYYY-MM-DD")
  );
  const [reorderSelectedRadio, setReorderSelectedRadio] = useState(
    reorderDateFilterData?.selectedRadio || "month"
  );
  const physicalDateFilterData = JSON.parse(
    localStorage.getItem("physicalDateFilter")
  );
  const [openPhysicalDateModal, setOpenPhysicalDateModal] = useState(false);
  const [physicalStartDate, setPhysicalStartDate] = useState(
    physicalDateFilterData?.startDate ||
      dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [physicalEndDate, setPhysicalEndDate] = useState(
    physicalDateFilterData?.endDate ||
      dayjs().endOf("month").format("YYYY-MM-DD")
  );
  const [physicalSelectedRadio, setPhysicalSelectedRadio] = useState(
    physicalDateFilterData?.selectedRadio || "month"
  );
  const [DeleteInventory, setDeleteInventory] = useState("");
  const [openHistory, setOpenHistory] = useState(false);
  const [historyId, setHistoryId] = useState(null);

  const fetchDepartment = () => {
    setLoading(true);
    httpService
      .get("inventory/departments")
      .then((response) => {
        setDepartment(response.data); // Assuming the response is an array of rows
        setTimeout(() => {
          setLoading(false);
        }, 300);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching data:", error);
      });
  };

  const fetchReorder = () => {
    setLoading(true);
    httpService
      .get(
        `inventory/reorder?start_date=${reorderStartDate}&end_date=${reorderEndDate}&search=${searchReorderData}`
      )
      .then((response) => {
        setReorder(response?.data);
        setTimeout(() => {
          setLoading(false);
        }, 300);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching data:", error);
      });
  };

  const fetchStocks = (id) => {
    setLoading(true);
    setStocks([]);
    httpService
      .get(
        `inventory/stock?department_id=${id}&start_date=${physicalStartDate}&end_date=${physicalEndDate}&search=${searchPhysicalData}`
      )
      .then((response) => {
        setStocks(response?.data);
        setTimeout(() => {
          setLoading(false);
        }, 300);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    fetchDepartment();
    const dateFilterData = JSON.parse(
      localStorage.getItem("reorderDateFilter")
    );

    if (dateFilterData) {
      setReorderStartDate(dateFilterData?.startDate);
      setReorderEndDate(dateFilterData?.endDate);
      setReorderSelectedRadio(dateFilterData?.selectedRadio);
    } else {
      const dateFilter = {
        startDate: dayjs().startOf("month").format("YYYY-MM-DD"),
        endDate: dayjs().endOf("month").format("YYYY-MM-DD"),
        selectedRadio: "month",
      };
      localStorage.setItem("reorderDateFilter", JSON.stringify(dateFilter));
    }
    fetchReorder();
  }, [searchReorderData]);

  useEffect(() => {
    const dateFilterData = JSON.parse(
      localStorage.getItem("physicalDateFilter")
    );

    if (dateFilterData) {
      setPhysicalStartDate(dateFilterData?.startDate);
      setPhysicalEndDate(dateFilterData?.endDate);
      setPhysicalSelectedRadio(dateFilterData?.selectedRadio);
    } else {
      const dateFilter = {
        startDate: dayjs().startOf("month").format("YYYY-MM-DD"),
        endDate: dayjs().endOf("month").format("YYYY-MM-DD"),
        selectedRadio: "month",
      };
      localStorage.setItem("physicalDateFilter", JSON.stringify(dateFilter));
    }
    if (departments.length > 0) {
      setActiveTab(departments[0].id);
      fetchStocks(departments[0].id);
    }
  }, [departments, searchPhysicalData]);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .ant-empty-img-1": {
      fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
    },
    "& .ant-empty-img-2": {
      fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
    },
    "& .ant-empty-img-3": {
      fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
    },
    "& .ant-empty-img-4": {
      fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
    },
    "& .ant-empty-img-5": {
      fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
      fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
    },
  }));

  function CustomNoRowsOverlay() {
    return (
      <StyledGridOverlay>
        <Box sx={{ mt: 1 }}>No Data Found</Box>
      </StyledGridOverlay>
    );
  }

  const other = {
    showCellVerticalBorder: true,
    showColumnVerticalBorder: true,
  };

  const downloadReorderExcel = async (setShowLoginPopup, selectedIds) => {
    await handleDownloadReorderExcel(setShowLoginPopup, selectedIds);
  };

  const downloadPhysicalInventoryExcel = async (
    setShowLoginPopup,
    selectedIds
  ) => {
    await handleDownloadPhysicalInventoryExcel(setShowLoginPopup, selectedIds);
  };

  const reorderDownload = InventoryDownloadHandler({
    rows: reorder,
    downloadHandler: downloadReorderExcel,
    setShowLoginPopup,
  });

  const physicalDownload = InventoryDownloadHandler({
    rows: stocks,
    downloadHandler: downloadPhysicalInventoryExcel,
    setShowLoginPopup,
  });

  const HandleDeleteInventory = async () => {
    if (DeleteInventory) {
      try {
        const response = await httpService.delete(
          `${"inventory/stock"}/${DeleteInventory}`
        );
        if (response) {
          fetchReorder();
          if (departments.length > 0) {
            setActiveTab(departments[0].id);
            fetchStocks(departments[0].id);
          }
          toast.success("Inventory Deleted successfully", {
            position: "top-right",
          });
        } else {
          throw response;
        }
        setOpenDelete(false);
        fetchReorder();
        if (departments.length > 0) {
          setActiveTab(departments[0].id);
          fetchStocks(departments[0].id);
        }
      } catch (error) {
        setOpenDelete(false);
        toast.error(error?.response?.data?.error, {
          position: "top-right",
        });
      }
    }
  };

  const updateReorderStatus = async (id, reorder_status) => {
    const response = httpService.put(`inventory/reorder-status/${id}`, {
      reorder_status,
    });
    if (response) {
      fetchReorder();
      fetchStocks(activeTab);
    }
  };

  const viewPage = (id) => {
    const urlEncodedId = Encryption(id);
    navigate(`/inventory/view/${urlEncodedId}`, {
      state: {
        from: "reorderInventory",
      },
    });
  };

  return (
    <>
      {loading && <FullScreenLoader />}
      <div className="inventory mb-5">
        <div className="page-title">
          <div className="title-wrap">
            <h1>Reorder Request</h1>
          </div>
        </div>
        <div className="table-filter-wrap d-flex justify-content-between">
          <div className="header_search-wrap">
            <div className="header_search_bar common_content">
              <div className="input-group input_group">
                <button className="btn search-btn search_btn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 21 21"
                    fill="none"
                  >
                    <circle
                      cx="9.98856"
                      cy="9.98856"
                      r="8.98856"
                      stroke="#495057"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M16.2402 16.7071L19.7643 20.222"
                      stroke="#495057"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <input
                  type="search"
                  className="form-control form_control"
                  placeholder="Search..."
                  aria-label="Search"
                  onChange={(e) => {
                    const value = e.target.value;
                    setSearchReorderData(value);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="d-flex flex-row">
            <Button
              variant="contained"
              color="primary"
              className="me-3"
              onClick={reorderDownload.onDownloadClick}
              startIcon={<FaFileExcel />}
              disabled={reorderDownload.selectedIds?.length > 0 ? false : true}
              style={{ textTransform: "none", fontSize: "17px" }}
            >
              Download
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => setOpenReorderDateModal(true)}
              className="filters-btn"
            >
              <TbFilterEdit /> Filter
            </Button>
          </div>
        </div>
        <div style={{ height: 459, width: "100%" }}>
          <DataGrid
            slots={{
              noRowsOverlay: CustomNoRowsOverlay,
            }}
            rows={reorder}
            getRowHeight={() => "auto"}
            sx={{
              [`& .${gridClasses.cell}`]: {
                py: 0.5,
              },
            }}
            columnHeaderHeight={60}
            columns={[
              // {
              //   field: "action",
              //   headerName: "Actions",
              //   headerAlign: "center",
              //   align: "center",
              //   width: 100,
              //   disableColumnMenu: true,
              //   renderCell: (params) => (
              //     <>
              //       <div className="action_icon-weap">
              //         <IconButton
              //           onClick={(e) => {
              //             handleMenuClick(e), setDataId(params.row.id);
              //           }}
              //         >
              //           <GridMoreVertIcon />
              //         </IconButton>
              //       </div>
              //       {anchorEl && dataId === params?.row?.id && (
              //         <Popover
              //           className="popup-menu"
              //           key={dataId}
              //           open={Boolean(anchorEl)}
              //           anchorEl={anchorEl}
              //           onClose={handleCloseMenu}
              //           anchorOrigin={{
              //             vertical: "bottom",
              //             horizontal: "right",
              //           }}
              //           transformOrigin={{
              //             vertical: "top",
              //             horizontal: "right",
              //           }}
              //         >
              //           {/* <MenuItem
              //             onClick={() => {
              //               viewPage(dataId);
              //             }}
              //             className="menu-list-items"
              //           >
              //             <div className="menu-list-items-text">View</div>
              //             <HiOutlineEye style={{ cursor: "pointer" }} />
              //           </MenuItem> */}
              //           {/* <MenuItem
              //             onClick={() => {
              //               // console.log("params", params.row.id);
              //               // setOpenModel(true);
              //               // setIsAdd(false);
              //               // setInventory_Id(dataId);
              //               // handleCloseMenu();
              //             }}
              //             className="menu-list-items"
              //           >
              //             <div className="menu-list-items-text">Edit</div>
              //             <CiEdit style={{ cursor: "pointer" }} />
              //           </MenuItem> */}
              //           <MenuItem
              //             onClick={() => {
              //               setOpenDelete(true);
              //               setDeleteInventory(dataId);
              //               handleCloseMenu();
              //             }}
              //             className="menu-list-items"
              //           >
              //             <div className="menu-list-items-text">Delete</div>
              //             <GoTrash style={{ cursor: "pointer" }} />
              //           </MenuItem>
              //         </Popover>
              //       )}
              //     </>
              //   ),
              //   sortable: false,
              // },
              {
                field: "select_All",
                headerName: "Select All",
                minWidth: 30,
                align: "center",
                sortable: false,
                headerAlign: "center",
                disableColumnMenu: true,
                renderCell: (params) => {
                  return (
                    <Checkbox
                      checked={reorderDownload.isIdSelected(params.row.id)}
                      onChange={() => reorderDownload.toggleId(params.row.id)}
                    />
                  );
                },
                headerCheckboxSelection: true,
                renderHeader: (params) => {
                  return (
                    <>
                      <Checkbox
                        checked={reorderDownload.isAllSelected}
                        onChange={reorderDownload.handleHeaderCheckboxChange}
                      />
                    </>
                  );
                },
              },
              {
                field: "department_name",
                headerName: "Department",
                width: 200,
              },
              {
                field: "item_name",
                headerName: "Item Name",
                width: 200,
                sortable: true,
              },
              {
                field: "item_description",
                headerName: "Item Description",
                width: 200,
                sortable: true,
              },
              {
                field: "supplier",
                headerName: "Supplier Name",
                width: 150,
                sortable: true,
                headerAlign: "center",
                align: "center",
              },
              // {
              //   field: "stored_location",
              //   headerName: "Store Location",
              //   width: 200,
              //   headerClassName: "headerclass",
              // },
              {
                field: "reorder_threshold",
                headerName: "Reorder Threshold",
                width: 119,
                sortable: true,
                headerClassName: "headerclass",
                renderCell: (params) => {
                  const value = params.value;
                  const parsedValue = parseFloat(value);
                  const isNumber = !isNaN(parseFloat(value)) && isFinite(value);

                  return (
                    <div className="employee-name-weap">
                      <span>
                        {isNumber
                          ? `${parsedValue} ${params.row.unit_name || ""}`
                          : value || "as needed"}
                      </span>
                    </div>
                  );
                },
              },
              {
                field: "reorder_amount",
                headerName: "Reorder Amount",
                width: 119,
                sortable: true,
                headerClassName: "headerclass",
                renderCell: (params) => {
                  const value = params.value;
                  const parsedValue = parseFloat(value);
                  const isNumber = !isNaN(parseFloat(value)) && isFinite(value);

                  return (
                    <div className="employee-name-weap">
                      <span>
                        {isNumber
                          ? `${parsedValue} ${params.row.unit_name || ""}`
                          : value || "--"}
                      </span>
                    </div>
                  );
                },
              },
              {
                field: "reorder",
                headerName: "Reorder Yes/No",
                width: 115,
                sortable: true,
                headerClassName: "headerclass",
              },
              {
                field: "on_hand_qty",
                headerName: "On Hand Qty",
                width: 108,
                sortable: true,
                headerClassName: "headerclass",
                align: "center",
                renderCell: (params) => {
                  const value = params.value;
                  const parsedValue = parseFloat(value);
                  const isNumber = !isNaN(parseFloat(value)) && isFinite(value);
                  return (
                    <div className="employee-name-weap">
                      <span>
                        {isNumber
                          ? `${parsedValue} ${params.row.unit_name || ""}`
                          : value || "--"}
                      </span>
                    </div>
                  );
                },
              },
              {
                field: "emp_name",
                headerName: "Employee",
                width: 200,
                sortable: true,
                align: "center",
                headerAlign: "center",
              },
              {
                field: "date",
                headerName: "Date",
                width: 100,
                sortable: true,
                renderCell: (params) => {
                  return (
                    <div>{dayjs(params.row.date).format("MM/DD/YYYY")}</div>
                  );
                },
              },
            ]}
            initialState={{
              pagination: {
                rowCount: -1,
              },
            }}
            pagination={false}
            hideFooter
            sortingMode="client"
          />
        </div>
      </div>
      <div className="inventory">
        <div className="page-title">
          <div className="title-wrap">
            <h1>Physical Inventory</h1>
          </div>
        </div>
        <div
          className="w-100 d-flex align-items-center justify-content-between inventory-tab-wrapper"
          style={{
            // backgroundColor: "#00A272", // Matches your screenshot
            backgroundColor: "#FFF", // Matches your screenshot
            marginBottom: "20px",
          }}
        >
          {/* <div
            className="d-flex overflow-auto justify-content-between"
            style={{ whiteSpace: "nowrap" }}
          > */}
          {departments.map((tab) => (
            <div
              key={tab?.id}
              // className={`px-3 py-2 text-nowrap`}
              onClick={() => {
                setActiveTab(tab?.id);
                fetchStocks(tab?.id);
              }}
              style={{
                cursor: "pointer",
                color:
                  activeTab === tab?.id
                    ? tab?.color === "red"
                      ? "#D32F2F"
                      : "#00A272"
                    : tab?.color === "red"
                    ? "#D32F2F"
                    : // : "#A1A2A1",
                      "#00A272",
                fontWeight: activeTab === tab?.id ? 700 : 500,
                borderBottom:
                  activeTab === tab?.id
                    ? tab?.color === "red"
                      ? "4px solid #D32F2F"
                      : "4px solid #00A272"
                    : tab?.color === "red"
                    ? "1px solid #D32F2F"
                    : "1px solid #00A272",
                // : "1px solid #A1A2A1",
                minWidth: "100px",
                textAlign: "center",
                flexShrink: 0,
                padding: "12px 12px 12px 12px",
                fontFamily: "wf_light",
                fontSize: "16px",
                backgroundColor:
                  activeTab === tab?.id
                    ? tab?.color === "red"
                      ? "#FFE3E3"
                      : "#E6F6F1"
                    : "",
              }}
            >
              {tab?.name.replace(/_/g, " ")}
            </div>
          ))}
          {/* </div> */}
        </div>
        <div className="table-filter-wrap d-flex justify-content-between">
          <div className="header_search-wrap">
            <div className="header_search_bar common_content d-flex">
              <div className="input-group input_group">
                <button className="btn search-btn search_btn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 21 21"
                    fill="none"
                  >
                    <circle
                      cx="9.98856"
                      cy="9.98856"
                      r="8.98856"
                      stroke="#495057"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M16.2402 16.7071L19.7643 20.222"
                      stroke="#495057"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <input
                  type="search"
                  className="form-control form_control"
                  placeholder="Search..."
                  aria-label="Search"
                  onChange={(e) => {
                    const value = e.target.value;
                    setSearchPhysicalData(value);
                  }}
                />
              </div>
              <button
                className="btn btn-success ms-2"
                style={{
                  marginLeft: 8,
                  height: 40,
                  color: "white",
                  backgroundColor: "#00A272",
                  border: "none",
                  borderRadius: "4px",
                  padding: "8px 16px",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
                onClick={() => {
                  if (activeTab) {
                    const dept = departments.find((d) => d.id === activeTab);
                    navigate("/inventory/graph", {
                      state: {
                        departmentId: activeTab,
                        departmentName: dept ? dept.name : "",
                      },
                    });
                  } else {
                    alert("Please select a department to view the graph.");
                  }
                }}
                disabled={!activeTab}
              >
                Monitor
              </button>
            </div>
          </div>
          <div className="d-flex flex-row">
            <Button
              variant="contained"
              color="primary"
              className="me-3"
              onClick={physicalDownload.onDownloadClick}
              startIcon={<FaFileExcel />}
              disabled={physicalDownload.selectedIds?.length > 0 ? false : true}
              style={{ textTransform: "none", fontSize: "17px" }}
            >
              Download
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => setOpenPhysicalDateModal(true)}
              className="filters-btn"
            >
              <TbFilterEdit /> Filter
            </Button>
          </div>
        </div>
        <div style={{ height: 459, width: "100%" }}>
          <DataGrid
            slots={{
              noRowsOverlay: CustomNoRowsOverlay,
            }}
            rows={stocks}
            getRowHeight={() => "auto"}
            sx={{
              [`& .${gridClasses.cell}`]: {
                py: 0.5,
              },
            }}
            columnHeaderHeight={60}
            columns={[
              // {
              //   field: "action",
              //   headerName: "Actions",
              //   headerAlign: "center",
              //   align: "center",
              //   width: 100,
              //   disableColumnMenu: true,
              //   renderCell: (params) => (
              //     <>
              //       <div className="action_icon-weap">
              //         <IconButton
              //           onClick={(e) => {
              //             handleMenuClick(e), setDataId(params.row.id);
              //           }}
              //         >
              //           <GridMoreVertIcon />
              //         </IconButton>
              //       </div>
              //       {anchorEl && dataId === params?.row?.id && (
              //         <Popover
              //           className="popup-menu"
              //           key={dataId}
              //           open={Boolean(anchorEl)}
              //           anchorEl={anchorEl}
              //           onClose={handleCloseMenu}
              //           anchorOrigin={{
              //             vertical: "bottom",
              //             horizontal: "right",
              //           }}
              //           transformOrigin={{
              //             vertical: "top",
              //             horizontal: "right",
              //           }}
              //         >
              //           {/* <MenuItem
              //             onClick={() => {
              //               viewPage(dataId);
              //             }}
              //             className="menu-list-items"
              //           >
              //             <div className="menu-list-items-text">View</div>
              //             <HiOutlineEye style={{ cursor: "pointer" }} />
              //           </MenuItem> */}
              //           {/* <MenuItem
              //             onClick={() => {
              //               // console.log("params", params.row.id);
              //               // setOpenModel(true);
              //               // setIsAdd(false);
              //               // setInventory_Id(dataId);
              //               // handleCloseMenu();
              //             }}
              //             className="menu-list-items"
              //           >
              //             <div className="menu-list-items-text">Edit</div>
              //             <CiEdit style={{ cursor: "pointer" }} />
              //           </MenuItem> */}
              //           <MenuItem
              //             onClick={() => {
              //               setOpenDelete(true);
              //               setDeleteInventory(dataId);
              //               handleCloseMenu();
              //             }}
              //             className="menu-list-items"
              //           >
              //             <div className="menu-list-items-text">Delete</div>
              //             <GoTrash style={{ cursor: "pointer" }} />
              //           </MenuItem>
              //         </Popover>
              //       )}
              //     </>
              //   ),
              //   sortable: false,
              // },
              {
                field: "select_All",
                headerName: "Select All",
                minWidth: 30,
                align: "center",
                sortable: false,
                headerAlign: "center",
                disableColumnMenu: true,
                renderCell: (params) => {
                  return (
                    <Checkbox
                      checked={physicalDownload.isIdSelected(params.row.id)}
                      onChange={() => physicalDownload.toggleId(params.row.id)}
                    />
                  );
                },
                headerCheckboxSelection: true,
                renderHeader: (params) => {
                  return (
                    <>
                      <Checkbox
                        checked={physicalDownload.isAllSelected}
                        onChange={physicalDownload.handleHeaderCheckboxChange}
                      />
                    </>
                  );
                },
              },
              {
                field: "item_name",
                headerName: "Item Name",
                width: 200,
                headerClassName: "colurs",
                renderCell: (params) => {
                  const value = params.value;
                  const id = params.row.inventory_id;
                  return (
                    <div className="employee-name-weap">
                      <span
                        onClick={() => viewPage(id)}
                        style={{
                          cursor: "pointer",
                          color: "#7171f1",
                          textDecorationLine: "underline",
                        }}
                      >
                        <span>{value}</span>
                      </span>
                    </div>
                  );
                },
              },
              {
                field: "item_description",
                headerName: "Item Description",
                width: 200,
                sortable: true,
                headerAlign: "center",
                align: "center",
              },
              {
                field: "supplier",
                headerName: "Supplier Name",
                width: 200,
                sortable: true,
                headerAlign: "center",
                align: "center",
              },
              {
                field: "history",
                headerName: "History",
                width: 120,
                align: "center",
                headerAlign: "center",
                sortable: false,
                headerAlign: "center",
                align: "center",
                renderCell: (params) => (
                  <span
                    className="show-history"
                    style={{
                      color: "#7171f1",
                      cursor: "pointer",
                      textDecoration: "underline",
                      fontWeight: 500,
                    }}
                    onClick={() => {
                      setHistoryId(params.row.inventory_id);
                      setOpenHistory(true);
                    }}
                  >
                    View History
                  </span>
                ),
              },
              // {
              //   field: "stored_location",
              //   headerName: "Store Location",
              //   width: 200,
              //   headerClassName: "headerclass",
              // },
              {
                field: "reorder_threshold",
                headerName: "Reorder Threshold",
                width: 130,
                sortable: true,
                headerClassName: "headerclass",
                renderCell: (params) => {
                  const value = params.value;
                  const parsedValue = parseFloat(value);
                  const isNumber = !isNaN(parseFloat(value)) && isFinite(value);

                  return (
                    <div className="employee-name-weap">
                      <span>
                        {isNumber
                          ? `${parsedValue} ${params.row.unit_name || ""}`
                          : value || "as needed"}
                      </span>
                    </div>
                  );
                },
              },
              {
                field: "reorder_amount",
                headerName: "Reorder Amount",
                width: 130,
                sortable: true,
                headerClassName: "headerclass",
                renderCell: (params) => {
                  const value = params.value;
                  const parsedValue = parseFloat(value);
                  const isNumber = !isNaN(parseFloat(value)) && isFinite(value);

                  return (
                    <div className="employee-name-weap">
                      <span>
                        {isNumber
                          ? `${parsedValue} ${params.row.unit_name || ""}`
                          : value || "--"}
                      </span>
                    </div>
                  );
                },
              },
              {
                field: "reorder",
                headerName: "Reorder Yes/No",
                width: 115,
                sortable: true,
                headerClassName: "headerclass",
              },
              {
                field: "on_hand_qty",
                headerName: "On Hand Qty",
                width: 130,
                sortable: true,
                headerClassName: "headerclass",
                align: "center",
                renderCell: (params) => {
                  const value = params.value;
                  const parsedValue = parseFloat(value);
                  const isNumber = !isNaN(parseFloat(value)) && isFinite(value);
                  return (
                    <div className="employee-name-weap">
                      <span>
                        {isNumber
                          ? `${parsedValue} ${params.row.unit_name || ""}`
                          : value || "--"}
                      </span>
                    </div>
                  );
                },
              },
              {
                field: "emp_name",
                headerName: "Employee",
                width: 160,
                sortable: true,
                align: "center",
                headerClassName: "headerclass",
                headerAlign: "center",
                align: "center",
              },
              {
                field: "date",
                headerName: "Date",
                width: 130,
                sortable: true,
                renderCell: (params) => {
                  return (
                    <div>{dayjs(params.row.date).format("MM/DD/YYYY")}</div>
                  );
                },
              },
              {
                field: "reorder_status",
                headerName: "Select To Reorder",
                width: 100,
                sortable: false,
                align: "center",
                headerAlign: "center",
                headerClassName: "headerclass",
                renderCell: (params) => {
                  const thresholdIsNumber =
                    !isNaN(parseFloat(params.row?.reorder_threshold)) &&
                    isFinite(params.row?.reorder_threshold);
                  const reorderAmountIsNumber =
                    !isNaN(parseFloat(params.row?.reorder_amount)) &&
                    isFinite(params.row?.reorder_amount);
                  return (params.row?.reorder !== "yes" &&
                    !thresholdIsNumber) ||
                    !reorderAmountIsNumber ? (
                    <Checkbox
                      checked={Boolean(params.value)}
                      onChange={(e) =>
                        updateReorderStatus(params.row.id, e.target.checked)
                      }
                    />
                  ) : null;
                },
              },
            ]}
            sortingMode="client"
            pagination={false}
            hideFooter
          />
        </div>
      </div>
      {openReorderDateModal && (
        <DateTimeModal
          handleDateTimeModal={() => setOpenReorderDateModal(false)}
          setStartDate={(e) => setReorderStartDate(e)}
          setEndDate={(e) => setReorderEndDate(e)}
          open={openReorderDateModal}
          fetchSchedule={() => {
            fetchReorder();
            const dateFilter = {
              startDate: reorderStartDate,
              endDate: reorderEndDate,
              selectedRadio: reorderSelectedRadio,
            };
            localStorage.setItem(
              "reorderDateFilter",
              JSON.stringify(dateFilter)
            );
          }}
          selectedRadio={reorderSelectedRadio}
          setSelectedRadio={(e) => setReorderSelectedRadio(e)}
          startDate={reorderStartDate}
          endDate={reorderEndDate}
        />
      )}
      {openPhysicalDateModal && (
        <DateTimeModal
          handleDateTimeModal={() => setOpenPhysicalDateModal(false)}
          setStartDate={(e) => setPhysicalStartDate(e)}
          setEndDate={(e) => setPhysicalEndDate(e)}
          open={openPhysicalDateModal}
          fetchSchedule={() => {
            fetchStocks(activeTab);
            const dateFilter = {
              startDate: physicalStartDate,
              endDate: physicalEndDate,
              selectedRadio: physicalSelectedRadio,
            };
            localStorage.setItem(
              "physicalDateFilter",
              JSON.stringify(dateFilter)
            );
          }}
          selectedRadio={physicalSelectedRadio}
          setSelectedRadio={(e) => setPhysicalSelectedRadio(e)}
          startDate={physicalStartDate}
          endDate={physicalEndDate}
        />
      )}
      <DeleteModal
        open={openDelete}
        HandleClose={() => handleClose()}
        HandleDelete={() => {
          HandleDeleteInventory();
          setDeleteInventory("");
        }}
      />
      {openHistory && (
        <HistoryModal
          open={openHistory}
          handleClose={() => setOpenHistory(false)}
          id={historyId}
        />
      )}
    </>
  );
};

export default ReorderInventory;
